<template>
  <div>
    <MenuView v-if="websiteFormat === 'menu_only'" />
    <TemplateView v-else-if="['liquor', 'tobacco'].includes(websiteFormat)" />
    <StoreInfoRewardsView v-else-if="websiteFormat === 'store_info_rewards'" />

    <template v-else>
      <XsDepartments v-if="$vuetify.breakpoint.xsOnly" />
      <Departments v-else />
    </template>
    <OrderReceivedDialog
      v-if="
        !(storeInfo.delivery_name === 'Bringg' && order.service === 'DELIVERY')
      "
    />
  </div>
</template>

<script>
import { getProductDetailViewFromProductState } from "@/util.js";
import { mapGetters, mapState } from "vuex";
import Departments from "@/components/Departments/Departments.vue";
import XsDepartments from "@/components/Departments/Xs/Departments.vue";
import MenuView from "@/views/Menu.vue";
import TemplateView from "@/components/Template/Template.vue";
import { getUrlParams } from "@/helper";
import OrderReceivedDialog from "@/components/Order/Dialogs/Received.vue";
import StoreInfoRewardsView from "@/components/StoreInfoRewards/StoreInfoRewards.vue";

//local testing
//const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export default {
  name: "HomeView",
  components: {
    OrderReceivedDialog,
    TemplateView,
    MenuView,
    Departments,
    XsDepartments,
    StoreInfoRewardsView,
  },
  computed: {
    ...mapGetters({
      getProductItemsAndQuantityInCart: "cart/getProductItemsAndQuantityInCart",
    }),
    ...mapState({
      noProductFound: (state) => state.product.noProductFound,
      order: (state) => state.orders.order,
      product: (state) => state.product.details,
      storeInfo: (state) => state.store.info,
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
    }),
    cartProduct() {
      const itemsAndQuantityFromCart = this.getProductItemsAndQuantityInCart(
        this.product,
      );
      return { ...this.product, ...itemsAndQuantityFromCart };
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
  async created() {
    this.$route.params.token && this.routeToResetPassword();
  },
  async mounted() {
    const params = getUrlParams();
    if (params.orderId) {
      //local testing
      //await delay(15000);
      await this.$store.dispatch("orders/payNowSuccess");
      await this.$store.commit("orders/OPEN_ORDER_RECEIVED_DIALOG");
    }
  },

  methods: {
    deleteUpcFromRouteToStopWatch() {
      delete this.$route.params.upc;
    },
    routeToResetPassword() {
      this.$vuetify.breakpoint.smAndUp
        ? this.$store.commit("auth/OPEN", true)
        : this.$router.push({
            name: "resetPassword",
            params: { token: this.$route.params.token },
          });
    },
    async openOrderReceivedDialog() {
      await this.$store.commit("orders/OPEN_ORDER_RECEIVED_DIALOG");
    },
  },

  watch: {
    $route(to) {
      // Check if the URL parameters are set
      if (to.query && to.query.orderId) {
        // Call the function when the URL parameters are available
        this.openOrderReceivedDialog();
      }
    },

    "$store.state.cart.products": async function () {
      const upcFromRoute = this.$route.params.upc;

      if (!upcFromRoute) {
        return;
      }

      this.deleteUpcFromRouteToStopWatch();

      // the cart products are necessary to initialize the product in getProduct
      this.$store.commit("product/PRODUCT_NOT_FOUND", false);
      await this.$store.dispatch("product/getProduct", upcFromRoute);

      const view = getProductDetailViewFromProductState(this.product);
      !this.noProductFound && this.$store.dispatch("product/openDialog", view);
    },
  },
};
</script>
